/*
  CONTACT — écrire à Adrien
  Pour Adrien d'Elzius · page Contact v2

  Le formulaire suit l'objet choisi : champs en plus, texte d'exemple.
  Les champs d'un objet non choisi sont désactivés, donc pas envoyés.
  Arrivée depuis une fiche (?oeuvre=…) : l'œuvre est déjà choisie.
  Les erreurs s'affichent sous le champ, en le quittant ou à l'envoi.
  Après l'envoi, la confirmation rappelle l'adresse et le message.
*/
(function () {
  var CLE = 'ctc-envoi';

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function norme(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, "'").trim(); }

  function lire() { try { return JSON.parse(sessionStorage.getItem(CLE) || 'null'); } catch (e) { return null; } }
  function ecrire(v) { try { sessionStorage.setItem(CLE, JSON.stringify(v)); } catch (e) {} }
  function oublier() { try { sessionStorage.removeItem(CLE); } catch (e) {} }

  function init(root) {
    if (root.__ctc) return;
    root.__ctc = 1;

    /* ────────── après l'envoi ────────── */
    var fini = root.querySelector('[data-ctc-done]');
    if (fini) {
      var envoi = lire();
      if (envoi) {
        var m = fini.querySelector('[data-ctc-done-mail]');
        if (m && envoi.mail) { m.querySelector('strong').textContent = envoi.mail; m.hidden = false; }
        var r = fini.querySelector('[data-ctc-recap]');
        if (r && envoi.texte) {
          r.querySelector('[data-ctc-recap-k]').textContent = envoi.objet || '';
          r.querySelector('[data-ctc-recap-t]').textContent = '« ' + envoi.texte + ' »';
          r.hidden = false;
        }
        oublier();
      }
      fini.scrollIntoView({ block: 'start' });
      fini.focus({ preventScroll: true });
      return;
    }

    var form = root.querySelector('form.ctc__form') || root.querySelector('form');
    if (!form) return;
    form.noValidate = true;

    var radios = $$('[data-ctc-objet]', form);
    var groupes = $$('[data-ctc-extra]', form);
    var corps = form.querySelector('textarea[name="contact[body]"]');
    var mail = form.querySelector('input[name="contact[email]"]');
    var bouton = form.querySelector('[data-ctc-send]');
    var bandeau = form.querySelector('[data-ctc-banner]');
    var phDefaut = corps ? corps.getAttribute('placeholder') : '';

    /* ────────── l'objet ────────── */
    function objetActif() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }
    function selectOeuvre() {
      var g = groupes.filter(function (x) { return !x.hidden; })[0];
      return g ? g.querySelector('[data-ctc-oeuvre]') : null;
    }

    function majBandeau() {
      if (!bandeau) return;
      var sel = selectOeuvre();
      var opt = sel && sel.value ? sel.options[sel.selectedIndex] : null;
      if (!opt || !opt.getAttribute('data-price')) { bandeau.hidden = true; return; }
      var img = bandeau.querySelector('[data-ctc-banner-img]');
      var src = opt.getAttribute('data-img');
      if (img) { if (src) { img.src = src; img.hidden = false; } else { img.hidden = true; } }
      bandeau.querySelector('[data-ctc-banner-name]').textContent = opt.value + ' · ' + opt.getAttribute('data-price');
      bandeau.hidden = false;
    }

    function appliquer() {
      var r = objetActif();
      if (!r) return;
      var k = r.getAttribute('data-ctc-objet');
      groupes.forEach(function (g) {
        var on = g.getAttribute('data-ctc-extra') === k;
        g.hidden = !on;
        $$('input, select, textarea', g).forEach(function (c) { c.disabled = !on; });
      });
      if (corps) corps.setAttribute('placeholder', r.getAttribute('data-ph') || phDefaut);
      majBandeau();
    }

    radios.forEach(function (r) { r.addEventListener('change', appliquer); });
    $$('[data-ctc-oeuvre]', form).forEach(function (s) { s.addEventListener('change', majBandeau); });
    var changer = form.querySelector('[data-ctc-banner-change]');
    if (changer) changer.addEventListener('click', function () { var s = selectOeuvre(); if (s) s.focus(); });

    /* ────────── arrivée depuis une fiche ────────── */
    var q = new URLSearchParams(window.location.search);
    var oeuvre = q.get('oeuvre');
    var objet = q.get('objet');
    var cible = null;
    if (objet) cible = radios.filter(function (r) { return norme(r.value) === norme(objet); })[0] || null;
    if (!cible && oeuvre) cible = radios.filter(function (r) { return r.hasAttribute('data-oeuvres'); })[0] || null;
    if (cible) cible.checked = true;
    appliquer();
    if (oeuvre) {
      var sel = selectOeuvre();
      if (sel) {
        var trouve = Array.prototype.filter.call(sel.options, function (o) { return norme(o.value) === norme(oeuvre); })[0];
        if (trouve) { sel.value = trouve.value; majBandeau(); }
      }
    }

    /* ────────── les erreurs, sous le champ ────────── */
    function erreur(champ, message) {
      var id = champ.getAttribute('aria-describedby');
      var p = id ? document.getElementById(id) : null;
      if (message) champ.setAttribute('aria-invalid', 'true'); else champ.removeAttribute('aria-invalid');
      if (p) p.textContent = message || '';
    }
    function verifier(champ) {
      if (!champ) return true;
      var v = champ.value.trim();
      var ok = true, msg = '';
      if (champ === mail) {
        ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
        msg = root.getAttribute('data-err-email');
      } else if (champ === corps) {
        ok = v.length > 0;
        msg = root.getAttribute('data-err-body');
      }
      erreur(champ, ok ? '' : msg);
      return ok;
    }
    [mail, corps].forEach(function (c) {
      if (!c) return;
      c.addEventListener('blur', function () { if (c.value.trim() || c.__touche) verifier(c); c.__touche = true; });
      c.addEventListener('input', function () { if (c.getAttribute('aria-invalid') === 'true') verifier(c); });
    });

    /* ────────── l'envoi ────────── */
    form.addEventListener('submit', function (e) {
      var okMail = verifier(mail);
      var okCorps = verifier(corps);
      if (!okMail || !okCorps) {
        e.preventDefault();
        (okMail ? corps : mail).focus();
        return;
      }
      var r = objetActif();
      var texte = corps.value.trim().replace(/\s+/g, ' ');
      ecrire({ mail: mail.value.trim(), objet: r ? r.value : '', texte: texte.length > 180 ? texte.slice(0, 177) + '…' : texte });
      if (bouton) { bouton.setAttribute('data-state', 'busy'); bouton.setAttribute('aria-busy', 'true'); }
    });
    // Retour arrière vers la page : le bouton ne reste pas bloqué.
    window.addEventListener('pageshow', function () {
      if (bouton) { bouton.setAttribute('data-state', 'rest'); bouton.removeAttribute('aria-busy'); }
    });
  }

  function demarrer(scope) { $$('[data-ctc]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { demarrer(document); });
  else demarrer(document);
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
